import React, { useState } from "react";
import auth from "../../services/Auth";
import { Navigate } from "services/Router";
import { startSSOLogin } from "../../services/AuthUtil";
import { Login as LoginComponent } from "../../components";

// relevant login errors
const NEED_MFA = 1;
const MFA_ERROR = 2;
const OTHER_ERROR = 3;

const Login = (props) => {
  const [alreadyAuth,setAlreadyAuth] = useState(auth.isAuthenticated());
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [newpassword, setNewpassword] = useState("");
  const [authMethods, setAuthMethods] = useState();
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [mfa, setMfa] = useState(false);
  const [mfactor, setMfactor] = useState("");
  const [msecure, setMsecure] = useState(false);
  const [usepasskey, setUsepasskey] = useState(false);    

  const handleUsername = (e) => setUsername(e.target.value);

  const handlePassword = (e) => setPassword(e.target.value);

  const handleNewPassword = (e) => setNewpassword(e.target.value);

  const handleMFA = (e) => setMfactor(e.target.value);

  const clearMFA = () => setMfactor("");

  const handleSecure = (e) => setMsecure(e.target.checked);

  const handleLoginError = (err) => {
    if (err.Message === "Correct MFA Token is required.") {
        if (mfa) {
            setError("MFA token provided is invalid.");
            return MFA_ERROR;
        } else {
            // just determined MFA needed, don't show error
            setMfa(true);
            return NEED_MFA;
        }
    } else {
        setError(err.Message);
        return OTHER_ERROR;
    }
  }

  const chooseMethod = (method) => {
      console.log("Auth with",method);
      if (method.method === 'password') {
          setShowPassword(true);
      } else if (method.method === 'passkey') {
          setError("");
          setDisabled(true);
          auth.loginPasskey(username, method.passkey).then((isAuthenticated) => {
              finish_login();
          }).catch((err) => {
              console.log("ERROR", err);
              const reason = handleLoginError(err)
              if (reason === NEED_MFA) {
                setUsepasskey(true);
              }
              setDisabled(false);
          });
      } else { //default to SSO
          startSSOLogin(method, username).then(status => {
              setError(status);
          });
      }
  };

  //this will deposit access token in auth service    
   const finish_login = () => {
       auth.fetch("/api/users/me").then(async (response) => {
          response = await response.json();
          const user = {};
          user["userid"] = response.guuid;
          user["name"] = response.name;
          user["username"] = response.email;
          user["userRoles"] = response.user_roles;
          user["dashboards"] = response.dashboards;
          user["orgs"] = response.orgs;
          user["session"] = response.session;
          user["readOnly"] = response.access === "readonly";
          console.log("USER", user);
          //talk to stuart/mike about how to get to dashboard here
          //not sure about next few lines of code
          setAlreadyAuth(true);
      })                  
   }
   const cancelLogin = async () => {
       window.location.reload();
   }
        
   const handleResetpass = (uname) =>
       auth.resetpass(username).then( () => {  console.log("SOMETHING"); });

   const loginMaybePasskey = async (pk,skipMFA) => {
       if(pk) return  auth.loginPasskey(username,
                                        authMethods.find(a => a.method === "passkey")?.passkey,
                                        mfactor,
                                        msecure);
       else return auth.login(username,password,(skipMFA===true) ? undefined : mfactor,msecure);
   }
    
   const attemptLogin = async (skipMFA) => {
       if(!username) {
           setError("Provide username.")
       } else if(!showPassword && !authMethods) { //still in phase 1
           auth.loginType(username).then((a) => {
               const auth_methods = a.auth_methods;
               if(Array.isArray(auth_methods)) {
                   if(auth_methods.length === 1) {
                       chooseMethod(auth_methods[0]);
                   } else {
                       setAuthMethods(auth_methods);
                   }
               }
           });
       } else {
           console.log("TRY LOGIN", username, password);
           if (username && (password || newpassword || usepasskey)) {
               setError("");
               setDisabled(true);
               loginMaybePasskey(usepasskey, skipMFA)
                   .then( (isAuthenticated) => { finish_login(); })
                   .catch((err) => {
                       handleLoginError(err);
                       setDisabled(false);
                   });
           } else {
               setError("Both username and password or passkey are required.")
           }
           
       }
   };    

    if(alreadyAuth) {
        return <Navigate to="/dashboard"/>
    }
    return (
      <LoginComponent
        attemptLogin={attemptLogin}
        username={username}
        cancelLogin={cancelLogin}        
        handleUsername={handleUsername}
        handlePassword={handlePassword}
        handleNewPassword={handleNewPassword}
        handleMFA={handleMFA}
        showPassword={showPassword}
        clearMFA={clearMFA}
        handleSecure={handleSecure}
        handleResetpass={handleResetpass}
        error={error}
        disabled={disabled}
        mfa={mfa}
        mfactor={mfactor}
        methods={authMethods}
        chooseMethod={chooseMethod}
        />
    );
};

export default Login;
